import { stageSpans } from './stageClock';
import type { StageEvent } from './stageClock';

/**
 * How long this job spent in every stage it has been through.
 *
 * The stage bar says WHERE a job is. This says how long it took to get there,
 * stage by stage — which is the thing Kyu actually wants pressure on: not
 * "did they miss the SLA" but "how fast are they, and where does the time go".
 *
 * Rendered on both sides from the same lens. A factory that can see its own
 * numbers can argue with them and improve them; a measurement kept on TAP's
 * screen only ever arrives as a complaint.
 *
 * Estimated spans say so. Orders that predate the stage log have their history
 * synthesised from the date columns that existed, and a span whose start or end
 * was guessed reads longer than it was. Marking it is cheaper than explaining
 * later why a number in a client email was wrong.
 */
export function StageTimeline({ events, today }: { events: StageEvent[]; today: string }) {
  const spans = stageSpans(events, today);
  if (spans.length === 0) {
    return null;
  }
  return (
    <ol className="stage-timeline">
      {spans.map((span, index) => (
        <li
          key={`${span.status}-${String(index)}`}
          className={
            span.isCurrent ? 'stage-timeline-row stage-timeline-row--now' : 'stage-timeline-row'
          }
        >
          <span className="stage-timeline-stage">{span.status}</span>
          <span className="stage-timeline-days">
            {span.days === 1 ? '1 day' : `${String(span.days)} days`}
            {span.isCurrent ? ' so far' : ''}
          </span>
          {/* Not a footnote. Somebody reading a row is deciding whether to
              quote it, and that decision needs the caveat on the same line. */}
          {span.isEstimate ? <span className="stage-timeline-estimate">estimated</span> : null}
        </li>
      ))}
    </ol>
  );
}
